<footer class="navbar-fixed-bottom bg-white ">
  <div class="container my-auto">
    <div class="copyright text-center my-auto">
      <span>&copy; {{current_year}} TopPredictor</span>
    </div>
  </div>
</footer>
